import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HomeSelector } from '../reducers/HomeReducer';
import { PaymentSelector } from '../reducers/PaymentReducer';
import SignupPaymentAction from '../actions/SignupPaymentAction';
import MyAccountAction from '../actions/MyAccountAction';
import ClickComponent from '../../components/clickPayment/ClickComponent';

// const mapDispatchToProps = dispatch =>
//   bindActionCreators({
//     checkSession: MyAccountAction.checkSession
//   }, dispatch);


// const UpdatePaymentContainer = connect(null, mapDispatchToProps)(UpdatePayment);

const mapStateToProps = state => ({
  toAddress: HomeSelector.getSelectedAddressParts(state),
  contactNumber: PaymentSelector.getContactNumber(state),
  email: PaymentSelector.getEmail(state),
  clickErrorStatus: PaymentSelector.getClickErrorStatus(state),
  amount: 0,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    storeClickGatewayDetails: SignupPaymentAction.storeClickGatewayDetails,
    callback: MyAccountAction.submitUpdatePayment,
    updateClickErrorMessage: SignupPaymentAction.updateClickErrorMessage
  }, dispatch);

const ClickUpdatePaymentContainer = connect(mapStateToProps, mapDispatchToProps)(ClickComponent);

export default ClickUpdatePaymentContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ClickUpdatePaymentContainer.js
 **/